import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/opt/tripening/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/tripening/layouts/default.vue").then(m => m.default || m)),
  "home-page": defineAsyncComponent(() => import("/opt/tripening/layouts/homePage.vue").then(m => m.default || m)),
  search: defineAsyncComponent(() => import("/opt/tripening/layouts/search.vue").then(m => m.default || m)),
  widget: defineAsyncComponent(() => import("/opt/tripening/layouts/widget.vue").then(m => m.default || m))
}